import { TextFieldVariants, TextField, MenuItem, Box } from "@mui/material";
import { FormTitle, IBaseLabelProps } from "../FormTitle/FormTitle";
import { EdgeUserType } from "../../../types";

interface ISearchInputField {
  value: string;
  onChange: (evt: any) => void;
  options: string[] | EdgeUserType[];
  label?: string;
  variant?: TextFieldVariants;
  error?: boolean;
}
export const SearchInput = (props: ISearchInputField & IBaseLabelProps) => {
  const {
    value,
    error,
    onChange,
    options,
    label,
    hint,
    required,
    variant = "standard",
    sx = {},
  } = props;

  return (
    <Box sx={{ mb: 2.5 }}>
      <FormTitle title={label} hint={hint} required={required} />
      <TextField
        error={error}
        select
        sx={{ width: "100%", ...sx }}
        variant={variant}
        value={value}
        onChange={onChange}
      >
        {options.map((option) =>
          <MenuItem key={option} value={option}>{option}</MenuItem>
        )}
      </TextField>
    </Box>
  );
};
